import React, { useEffect, useState, useRef } from "react";
import MetaTags from "react-meta-tags";
import SweetAlert from "react-bootstrap-sweetalert";
import Spinner from "components/spinner";
import noImage from "assets/images/PicUpload.jpg";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import fileIcon from "../../../src/assets/icons-image/document.png";
//redux
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import moment from "moment";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import { getAllDoctorsList } from "services/V2_APIs/DoctorsConsultationApis/doctorsInfo.service";
import CreateDoctor from "./Create";
import DoctorStatusBar from "./statusBar";

const DoctorsInfoList = props => {
  let UserId = JSON.parse(localStorage.getItem("authUser"))["_doc"]["_id"];
  let UserFirstname = JSON.parse(localStorage.getItem("authUser"))["_doc"][
    "firstname"
  ];
  let UserLastname = JSON.parse(localStorage.getItem("authUser"))["_doc"][
    "lastname"
  ];
  let Username = UserFirstname + " " + UserLastname;
  const [list, setList] = useState([]);
  // const [idList, setIdList] = useState({});
  const [allList, setAllList] = useState([]);
  const [search, setSearch] = useState("");
  const [TotalList, setTotalList] = useState([]);
  const [delete_modal, setDelete_modal] = useState(false);
  const [deleteId, setDeleteid] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [Statusmodal, setStatusModal] = useState(false);
  const [DoctorInfo, setDoctorInfo] = useState();
  const [tempList, setTempList] = useState([]);
  const [typeFilter, setTypeFilter] = useState(["Approved"]);
  const typeFilterOptions = ["Pending", "Approved", "Rejected"];

  const toggle = () => {
    setModal(!modal);
  };
  const toggleSatus = () => {
    setStatusModal(!Statusmodal);
  };

  useEffect(() => {
    getAllList();
  }, []);
  const getAllList = () => {
    setLoading(true);
    getAllDoctorsList()
      .then(res => {
        let result = res.data;
        setAllList(res?.data);
        setList(result);
        setTotalList(res?.data);
        setTempList(result);
        // let obj = {};
        // result.forEach(pr => {
        //   let id = pr._id;
        //   obj[id] = pr["access"];
        // });
        // setIdList(obj);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };
  const removeProvider = id => {
    deleteIndvidual(id)
      .then(res => {
        setDelete_modal(false);
        getAllList();
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onClickDelete = id => {
    setDeleteid(id);
    setDelete_modal(true);
  };

  const handleOnDelete = () => {
    removeProvider(deleteId);
  };

  const stayHere = () => {
    setDelete_modal(false);
  };

  const handleRoute = id => {
    props.history.push(`/individul-info/${id}`);
  };

  const deletePopup = () => {
    return (
      <SweetAlert
        title="Are you sure ?"
        warning
        onConfirm={handleOnDelete}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={handleOnDelete}
            >
              Delete
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              cancel
            </Button>
          </React.Fragment>
        }
      >
        You will not be able to recover this record
      </SweetAlert>
    );
  };

  const handleSearchByName = search => {
    if (search) {
      let tempList = _.cloneDeep(allList);
      let filterList = tempList.filter(
        ele =>
          ele?.fullName?.toLowerCase().includes(search.toLowerCase()) ||
          ele?.shortName?.toLowerCase().includes(search.toLowerCase())
      );
      setList(filterList);
    } else {
      setList(allList);
    }
  };

  useEffect(() => {
    if (typeFilter?.length > 0) {
      const newList = tempList.filter(obj =>
        typeFilter.includes(obj.verificationStatus)
      );
      setList(newList);
    } else {
      setList(tempList);
    }
  }, [typeFilter, tempList]);

  const handleCheckboxChange = text => {
    let newTypeFilter = [...typeFilter];
    let indx = newTypeFilter.indexOf(text);

    if (indx >= 0) {
      newTypeFilter.splice(indx, 1);
    } else {
      newTypeFilter.push(text);
    }
    setTypeFilter(newTypeFilter);
  };
  const checkboxItems = () => {
    return (
      <React.Fragment>
        {typeFilterOptions?.map((option, index) => {
          const isChecked = typeFilter.includes(option);
          return (
            <div className="d-flex me-3 align-items-center" key={index}>
              <Input
                key={option}
                id={option}
                type="checkbox"
                className="form-check-Inpu me-1 cursor-pointer"
                onChange={() => handleCheckboxChange(option)}
                defaultChecked={isChecked}
              />
              <Label
                className="form-check-Label fw-bold mb-0  pt-1  cursor-pointer"
                htmlFor={option}
              >
                {option}
              </Label>
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Individuals | stylepro - -</title>
        </MetaTags>
        <Spinner loading={loading} />
        <Container fluid>
          <Breadcrumbs title="Specialists" breadcrumbItem="Specialists List" />
          <BreadcrumbSub subtile="Specialists List" SubBreadcrumbItem="Specialists" />
          <div className="individual_list">
            <div className="d-flex align-items-center">
              <div>
                <h5 className="fw-bold">
                  Total Specialists: {TotalList?.length}
                </h5>
              </div>

              <div className="search-box ms-4 individual_search">
                <div className="position-relative">
                  <i className="bx bx-search-alt search-icon" />
                  <input
                    className="form-control py-2 bg-white"
                    type="search"
                    id="example-search-input"
                    placeholder="Search by name"
                    onChange={event => {
                      handleSearchByName(event.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              <Button
                type="button"
                color="primary"
                className=""
                onClick={() => {
                  toggle();
                }}
              >
                <i className="bx bx-user-plus me-1" />
                Create
              </Button>
            </div>
          </div>

          <div className="d-flex mt-3 align-items-center">
            {checkboxItems()}
          </div>
          {list?.length === 0 ? (
            <Card className="mt-3">
              <CardBody>
                <div className="p-5 text-center">
                  <h5>No results found</h5>
                </div>
              </CardBody>
            </Card>
          ) : (
            <Card className="bg-light my-3">
              <CardBody className="">
                <Row className="services-card">
                  {list?.map((doctor, index) => {
                    let FixedClass = "fw-bold ";
                    let statusClass =
                      doctor?.verificationStatus === "Approved"
                        ? FixedClass + "text-success"
                        : doctor?.verificationStatus === "Pending"
                        ? FixedClass + "text-warning"
                        : FixedClass + "text-danger";
                    let DoctorStatus = doctor?.verificationStatus;
                    return (
                      <Col
                        sm={6}
                        md={6}
                        xl={6}
                        xxl={4}
                        key={index}
                        className="mb-1"
                      >
                        <Card className="individual_cards">
                          <CardBody className="">
                            <div
                              className="view_button_1"
                              role="button"
                              onClick={() =>
                                window.open(
                                  `${process.env.REACT_APP_DOCTOR_PORTAL}/login/${doctor?._id}/ADMIN`,
                                  "_blank",
                                  "width=1200,height=800"
                                )
                              }
                            >
                              <img src={fileIcon} alt="" className="me-1" />
                            </div>
                            {/* {doctor?.status === "Verified" &&
                            partnerStatus === "Active" ? (
                              ""
                            ) : (
                              <div className="Delete_button mt-1">
                                <Badge
                                  role="button"
                                  className="font-size-10 badge-soft-danger py-1 px-2 me-1 fw-bold"
                                  color="bg-danger"
                                  onClick={() => onClickDelete(individual?._id)}
                                >
                                  <i className="bx bx-trash-alt font-size-12 fw-bold"></i>
                                </Badge>
                              </div>
                            )} */}
                            <div className="d-flex">
                              <div>
                                <div>
                                  <img
                                    className=""
                                    src={
                                      !doctor?.profileImage ||
                                      doctor?.profileImage === "undefined"
                                        ? noImage
                                        : doctor?.profileImage
                                    }
                                    alt=""
                                    width={100}
                                    height={100}
                                    role="button"
                                  />
                                </div>

                                <div>
                                  {DoctorStatus != "" ? (
                                    <div>
                                      <h6 className="text-center mt-2 parnership_status">
                                        {DoctorStatus === "Approved" ? (
                                          <i className="bx bx-check-shield text-success font-size-50"></i>
                                        ) : DoctorStatus === "Rejected" ? (
                                          <i className="bx bx-block text-danger font-size-50"></i>
                                        ) : (
                                          ""
                                        )}
                                      </h6>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="ms-4">
                                <h6 className="fw-bold font-size-16 individual_name text-uppercase">
                                  {doctor?.fullName} <br/>{doctor?.shortName != "" ? (<>({doctor?.shortName})</>):""}
                                </h6>

                                <h6 className="fw-bold" role="button">
                                  Reg #{doctor?.regNo}
                                </h6>
                                <div
                                  className="mb-1"
                                  onClick={() => {
                                    toggleSatus();
                                    setDoctorInfo(doctor);
                                  }}
                                  role="button"
                                >
                                  <span className="fw-bold">Status: </span>
                                  <span className={statusClass}>
                                    {doctor?.verificationStatus}
                                  </span>
                                </div>

                                <div className="mt-1">
                                  <span className="">
                                    Since:{" "}
                                    {doctor?.createdAt &&
                                      moment(
                                        new Date(doctor?.createdAt)
                                      ).format("DD MMM Y")}{" "}
                                  </span>
                                </div>
                                <div className="mt-1 d-flex align-items-center mobile_number">
                                  <i className="bx bxs-phone"></i>{" "}
                                  <span className="fw-bold mb-0 ps-1">
                                    {doctor?.mobileNumber}
                                  </span>
                                </div>
                                {doctor?.email && (
                                  <div className="mt-1 d-flex flex-wrap align-items-center mobile_number">
                                    <i className="bx bxs-envelope"></i>{" "}
                                    <span className="fw-bold mb-0 ps-1">
                                      {doctor?.email}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
      <CreateDoctor toggle={toggle} modal={modal} reload={getAllList} />
      <DoctorStatusBar
        toggle={toggleSatus}
        modal={Statusmodal}
        currentDoctor={DoctorInfo}
        reload={getAllList}
      />
      {delete_modal ? deletePopup() : null}
    </React.Fragment>
  );
};

export default DoctorsInfoList;
